export const banks = [
  {
    value: "na",
    displayValue: "N/A"
  },
  { value: "absa", displayValue: "Absa" },
  { value: "fnb", displayValue: "FNB" },
  { value: "capitec", displayValue: "Capitec" },
  { value: "nedbank", displayValue: "Nedbank" },
  {
    value: "standardbank",
    displayValue: "Standard Bank"
  },
  {
    value: "africanbank",
    displayValue: "African Bank"
  },
  {
    value: "mercantilebank",
    displayValue: "Mercantile Bank"
  },
  {
    value: "grindrodbank",
    displayValue: "Grindrod Bank"
  },
  {
    value: "bidvestbank",
    displayValue: "Bidvest Bank"
  },
  { value: "sasfin", displayValue: "Sasfin" },
  {
    value: "albarakabank",
    displayValue: "Albaraka Bank"
  },
  { value: "ubank", displayValue: "Ubank" },
  {
    value: "hbzbank",
    displayValue: "HBZ Bank"
  },
  {
    value: "southafricanbankofathens",
    displayValue: "South African Bank of Athens"
  },
  {
    value: "discoverybank",
    displayValue: "Discovery Bank"
  }
];


// WEBPACK FOOTER //
// ./src/views/Fna/steps/objects/banks.js